var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"modal-header pb-3 d-flex px-3 align-items-center justify-content-between"},[_c('h3',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.title))]),_c('font-awesome-icon',{staticClass:"close-icon-notification",attrs:{"icon":['fas', 'times']},on:{"click":_vm.sendCloseEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }